import React from 'react'
import { AppContext } from '../../context'

const BookmarksControl: React.FC = ({}) => {
  return (
    <AppContext.Consumer>
      {({ activePopover, onTogglePopover }) => (
        <button
          type="button"
          title="Bookmarks"
          aria-label="Bookmarks"
          onClick={() => onTogglePopover('bookmark')}
        >
          <span
            className={`mapboxgl-ctrl-button material-icons ${
              activePopover === 'bookmark' ? 'on' : ''
            }`}
          >
            bookmark
          </span>
        </button>
      )}
    </AppContext.Consumer>
  )
}

export default BookmarksControl
